import { registerModule } from "@eventdex/core";
import { setRealtimeConnected } from "./realtimeStatus";
class WebSocketService {
    constructor() {}

    registerHooks(socket) {
        this.socket = socket;
    
        socket.on("/event/PL_BLN_Tstatus__e", (data) => {
            console.log("Table status event received:", data);
            const event = new CustomEvent('tableStatus', { detail: data });
            window.dispatchEvent(event);
        });

        socket.on("/event/PL_BLN_TKT_PROFILE__e", (data) => {
            console.log("Attendee profile event received:", data);
            const event = new CustomEvent('attendeeProfile', { detail: data });
            window.dispatchEvent(event);
        });

        // A saved Design, for views that draw a room outside the builder store.
        socket.on("design-updated", (data) => {
            window.dispatchEvent(new CustomEvent('designUpdated', { detail: data }));
        });

        // Surface connection state so the Seat Assignment realtime bridge can
        // show clearly when the realtime channel is down and refetch when it is
        // restored (mapd-issues#656). There is deliberately no background poll.
        // Recorded as well as announced: a listener attached after the socket
        // was already up never hears `connect`, and needs to be able to ask
        // where things stand rather than assume the worst (mapd-issues#664).
        socket.on("connect", () => {
            setRealtimeConnected(true);
            window.dispatchEvent(new CustomEvent('realtimeConnected'));
        });
        socket.on("reconnect", () => {
            setRealtimeConnected(true);
            window.dispatchEvent(new CustomEvent('realtimeConnected'));
        });
        socket.on("disconnect", () => {
            setRealtimeConnected(false);
            window.dispatchEvent(new CustomEvent('realtimeDisconnected'));
        });

        if (socket.connected) setRealtimeConnected(true);
    }

}

const webSocket = new WebSocketService(); 

registerModule({
    webSocket
}); 

export default webSocket; 